import $i from "~/i18n";

export const saveSection = async (context, payload) => {
  context.commit("notifications/waiteUpload", {}, { root: true });
  try {
    let body = { ...payload };
    delete body.lectures;
    delete body.section;
    delete body.section_id;
    let { data } = await axios.post("/section/save", body);
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const updateSection = async (context, payload) => {
  context.commit("notifications/waiteUpload", {}, { root: true });
  try {
    let body = { ...payload };
    delete body.lectures;
    delete body.section;
    delete body.id;
    let { data } = await axios.post("/section/update-sections", body);
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const savePart = async (context, payload) => {
  context.commit("notifications/waiteUpload", {}, { root: true });
  try {
    let body = { ...payload.lecture };
    delete body.attachedFile;
    delete body.linkFile;
    var formData = new FormData();
    for (const key in body) {
      formData.append(key, body[key]);
    }
    let { data } = await axios.post("/lecture/save", formData, {
      onUploadProgress: function(progressEvent) {
        context.state.uploadPercentage = parseInt(
          Math.round((progressEvent.loaded * 100) / progressEvent.total)
        );
      }
    }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const getSections = async context => {
  try {
    let { data } = await axios.post("/section/get-all-sections", {
      course_id: parseInt(sessionStorage.getItem("course_id"))
    });
    if (data.state != 200) return;
    return data.sections;
  } catch (error) {
    console.log(error);
  }
};
export const getLects = async (context, payload) => {
  try {
    let { data } = await axios.post("/lecture/get-section-lectures", {
      id: parseInt(payload.id)
    });
    if (data.state != 200) return;
    return data.lectures;
  } catch (error) {
    console.log(error);
  }
};
export const updatePart = async (context, payload) => {
  context.commit("notifications/waiteUpload", {}, { root: true });
  try {
    let body = { ...payload.lecture };
    body.lecture_id = body.id;
    delete body.id;
    let { data } = await axios.post("/lecture/update-lecture", body);
    if (data.state !== 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    return data.lec_id;
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/sections/actions.js